import {
    GET_IP_WHITELIST_REQUEST,
    GET_IP_WHITELIST_SUCCESS,
    GET_IP_WHITELIST_FAILURE,
} from '../actions/getipwhitelistaction';

import {
    ADD_IP_WHITELIST_REQUEST,
    ADD_IP_WHITELIST_SUCCESS,
    ADD_IP_WHITELIST_FAILURE,
} from '../actions/addipwhitelistaction';

import {
    DELETE_IP_WHITELIST_REQUEST,
    DELETE_IP_WHITELIST_SUCCESS,
    DELETE_IP_WHITELIST_FAILURE,
} from '../actions/deleteipwhitelistaction';

import {
    UPDATE_IP_WHITELIST_REQUEST,
    UPDATE_IP_WHITELIST_SUCCESS,
    UPDATE_IP_WHITELIST_FAILURE,
} from '../actions/updateIPwhitelistAction';

// ── Get IP Whitelist Reducer ──────────────────────────────────────────────────
const getIpWhitelistInitialState = {
    loading: false,
    data: {
        status: '',
        description: '',
        ipWhitelistList: [],
    },
};

export const getIpWhitelistReducer = (state = getIpWhitelistInitialState, action) => {
    switch (action.type) {
        case GET_IP_WHITELIST_REQUEST:
            return { ...state, loading: true };
        case GET_IP_WHITELIST_SUCCESS:
            const operationList = action.payload.operationList;

            return {
                loading: false,
                data: {
                    status: action.payload.status || '',
                    description: action.payload.description || '',
                    ipWhitelistList: Array.isArray(operationList)
                        ? operationList       // multiple IPs → already an array
                        : operationList
                            ? [operationList]     // single IP object → wrap in array
                            : [],
                },
            };
        case GET_IP_WHITELIST_FAILURE:
            return {
                loading: false,
                data: { ...getIpWhitelistInitialState.data, description: action.payload },
            };
        default:
            return state;
    }
};

// ── Add IP Whitelist Reducer ──────────────────────────────────────────────────
const addIpWhitelistInitialState = {
    loading: false,
    data: {
        status: '',
        description: '',
    },
};


export const addIpWhitelistReducer = (state = addIpWhitelistInitialState, action) => {
    switch (action.type) {
        case ADD_IP_WHITELIST_REQUEST:
            return { ...state, loading: true };
        case ADD_IP_WHITELIST_SUCCESS:
            return {
                loading: false,
                data: {
                    status: action.payload.status || '',
                    description: action.payload.description || '',
                },
            };
        case ADD_IP_WHITELIST_FAILURE:
            return {
                loading: false,
                data: { ...addIpWhitelistInitialState.data, description: action.payload },
            };
        default:
            return state;
    }
};

// ── Update IP Whitelist Reducer ───────────────────────────────────────────────
const updateIPwhitelistInitialState = {
    loading: false,
    data: {
        status: '',
        description: '',
    },
};

export const updateIPwhitelistReducer = (state = updateIPwhitelistInitialState, action) => {
    switch (action.type) {
        case UPDATE_IP_WHITELIST_REQUEST:
            return { ...state, loading: true };
        case UPDATE_IP_WHITELIST_SUCCESS:
            return {
                loading: false,
                data: {
                    status: action.payload.status || '',
                    description: action.payload.description || '',
                },
            };
        case UPDATE_IP_WHITELIST_FAILURE:
            return {
                loading: false,
                data: { ...updateIPwhitelistInitialState.data, description: action.payload },
            };
        default:
            return state;
    }
};

// ── Delete IP Whitelist Reducer ───────────────────────────────────────────────
const deleteIpWhitelistInitialState = {
    loading: false,
    data: {
        status: '',
        description: '',
    },
};



export const deleteIpWhitelistReducer = (state = deleteIpWhitelistInitialState, action) => {
    switch (action.type) {
        case DELETE_IP_WHITELIST_REQUEST:
            return { ...state, loading: true };
        case DELETE_IP_WHITELIST_SUCCESS:
            return {
                loading: false,
                data: {
                    status: action.payload.status || '',
                    description: action.payload.description || '',
                },
            };
        case DELETE_IP_WHITELIST_FAILURE:
            return {
                loading: false,
                data: { ...deleteIpWhitelistInitialState.data, description: action.payload },
            };
        default:
            return state;
    }
};